import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import type Employee from 'modules/employees/store/models/Employee'
import type TimeoffPolicy from 'modules/timeoff/store/models/TimeoffPolicy/Policy'

interface Props {
  employee: Employee
  policy: TimeoffPolicy
}

const Options: React.FC<Props> = ({ employee, policy }) => {
  const { navigation } = useNavigation()

  const policyId = policy.attributes.id
  const employeeId = employee.attributes.id
  const pathname = navigation.settings.timeoffPolicies.id.employees.moveEmployeeId.fullPath({
    id: policyId,
    employeeId,
  })

  return (
    <Box paddingRight="s12">
      <PopoverMenu type="list">
        <PopoverMenu.Trigger>
          <Button.Decorative type="secondary" iconName="ellipsis" />
        </PopoverMenu.Trigger>
        <PopoverMenu.Content side="bottom" align="center">
          <PopoverMenu.RouterOption
            to={{ pathname }}
            title={i18n.t('settings.timeoff_policies.employees.actions.assign')}
          />
        </PopoverMenu.Content>
      </PopoverMenu>
    </Box>
  )
}

export default Options
